import { Component, OnInit } from '@angular/core';
import { ApiPartnerService } from '../../api/api-partner.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl} from '@angular/forms';
import {URLSearchParams} from '@angular/http';



@Component({
  selector: 'app-adminpartner-quota',
  templateUrl: './adminpartner-quota.component.html',
  styleUrls: ['./adminpartner.component.css']
})
export class AdminpartnerQuotaComponent implements OnInit {

 
  ServiceList: any = [];
  PartnerTrx: any = [];
  ServiceTrx: any = [];
  aboutme : [];

  table_load = false
  table_data = false

  paging : any = {};
  msearch : string;
  //paging_link : any = [];
  page_self = [];
  page_next = [];
  page_prev = [];
  meta = [];
  last_index : number;
  first_index : number;
  total_count : number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  href='';


  constructor(
  public partnerService: ApiPartnerService,
  private route: ActivatedRoute,
  private router: Router
    ) { 
  	
  }

  ngOnInit() {
    this.loadStart();
  }

  refreshPage() {
    this.ngOnInit();
  }

  loadStart() {
    let id = this.route.snapshot.paramMap.get('id');

    this.route.queryParams
      //.filter(params => params.order)
      .subscribe(params => {
        console.log(params); // {order: "popular"}

        //this.order = params.order;
        //console.log(this.order); // popular

        if (params.search != '' && params.search != undefined ){
          // console.log('search');
          // console.log(params.search);
         this.msearch = params.search; 
         this.querySearch = true;
        

         this.currentParams = params;
         this.queryParams = '?'+this.queryStr(params);
         this.loadServiceQuota(this.queryParams);
        
        }else{
          this.querySearch = false;
          this.currentParams = params;

          this.queryParams = '?'+this.queryStr(params);
          console.log(this.queryParams);
          console.log(this.queryStr(params));
          /* pagination */
          //this.loadworkorder(this.currentParams);
          this.loadServiceQuota(this.queryParams);
        }
      });
  }

  queryStr(options: any){
    let params = new URLSearchParams();
    for(let key in options){
        params.set(key, options[key]) 
    }
    return params.toString();
  }

  loadServiceQuota(params: any)
  {
    this.table_data = false
    this.table_load = true
    return this.partnerService.GetPartnerServiceQuota(params).subscribe((output: any) => {
        // console.log(output)
        this.ServiceList = output.data

        this.table_load = false
        this.table_data = true

        // start pagination
        this.paging = output.pagex;
        this.page_self = output.pagex.self;
        this.page_next = output.pagex.next;
        this.page_prev = output.pagex.prev;
        this.meta = output.meta;
        this.total_count = this.meta['totalCount'];
        let self = this.page_self['page'];
        if ( self * this.meta['perPage'] < this.meta['totalCount']){
          this.last_index = (self * this.meta['perPage']);
        }else{
          this.last_index = this.meta['totalCount'];
        }
        
        this.first_index = ((self-1)*this.meta['perPage'])+1;
        //end pagination
      })
  }  

  loadTrx(item: any) {
    let data = {
      "partnerid": item.partnerid,
      "productid": item.productid
    };

    return this.partnerService.GetPartnerServiceTrx(data).subscribe((output: any) => {
      // console.log(data)
      this.PartnerTrx = output.data
      this.ServiceTrx = output.data.servicetransaction
      // console.log(output.data)
    })
  }
  
}

